<template>
  <v-card>
    <!-- Navigation bar -->
    <v-app-bar app color="transparent">
      <v-app-bar-nav-icon color="white" @click.stop="toggleleftMenu"></v-app-bar-nav-icon>
      <!---
        This button will be used in the future for mobile viewing
      <v-btn color="transparent">
        <v-icon color="white">mdi-magnify</v-icon>
      </v-btn>
      ----->
      <!---->
      <v-responsive class="mx-auto mr-0" max-width="20%" color="black">
        <v-toolbar dense rounded color="ECEFF1">
          <v-autocomplete label="Search the globe..." style="margin-top: 30px;" :items="countries" dense rounded
            solo-inverted item-text='name' return-object @change="getCountry">
          </v-autocomplete>
        </v-toolbar>
      </v-responsive>
      <!--  Beginning of message icon and dialog box  -->
      <div class="d-flex justify-space-around">
        <v-menu :close-on-content-click="false" class="pt-9" transition="scale-transition">
          <template v-slot:activator="{ on, props }">
            <v-btn v-on="on" v-bind="props" min-width="0" color="transparent">
              <v-badge color="blue" overlap bordered dot>
                <v-icon color="grey lighten-2">mdi-message</v-icon>
              </v-badge>
            </v-btn>
          </template>
          <div class="pt-9 pl-5">
            <v-list>
              <v-list-item v-for="chat in recent" :key="chat.title">
                <v-list-item-avatar>
                  <v-img :alt="`${chat.title} avatar`" :src="chat.avatar"></v-img>
                </v-list-item-avatar>

                <v-list-item-content>
                  <v-list-item-title v-text="chat.title"></v-list-item-title>
                </v-list-item-content>

                <v-list-item-icon>
                  <v-badge color="blue" overlap bordered>
                    <v-icon :color="chat.active ? 'blue ighten-1' : 'grey'">
                      mdi-message
                    </v-icon>
                  </v-badge>
                </v-list-item-icon>
              </v-list-item>
            </v-list>

            <v-divider></v-divider>

            <v-list>
              <v-subheader>Previous chats</v-subheader>

              <v-list-item v-for="chat in previous" :key="chat.title">
                <v-list-item-avatar>
                  <v-img :alt="`${chat.title} avatar`" :src="chat.avatar"></v-img>
                </v-list-item-avatar>

                <v-list-item-content>
                  <v-list-item-title v-text="chat.title"></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </div>
        </v-menu>
      </div>
      <v-menu :close-on-content-click="false" class="pt-9 pr-9" transition="scale-transition">
        <template v-slot:activator="{ on, props }">
          <v-btn v-on="on" v-bind="props" min-width="0" color="transparent" class="pa-0">
            <v-badge color="blue" overlap bordered dot>
              <v-icon class="px-0" color="grey lighten-2">mdi-calendar-month</v-icon>
            </v-badge>
          </v-btn>
        </template>
        <div class="pt-9">
          <v-date-picker color="primary" v-model="date1" :events="arrayEvents" event-color="green lighten-1" />
        </div>
      </v-menu>
      <v-menu :close-on-content-click="false" elevation="0" class="pt-9 pr-9" transition="slide-x-transition">
        <template v-slot:activator="{ on, attrs }">
          <v-btn v-on="on" v-bind="attrs" min-width="0" color="transparent" icon dark @click="triggerTrendingNews()">
            <v-icon class="px-2" color="grey lighten-2">mdi-newspaper-variant</v-icon>
          </v-btn>
        </template>
        <v-list class="pt-9" color="transparent" width="450px" height="465px">
          <trendingNews :trendingNews="trendingNews" />
        </v-list>
      </v-menu>
      <v-menu :close-on-content-click="false" class="pt-9 pr-9" transition="slide-x-transition">
        <template v-slot:activator="{ on, props }">
          <v-btn v-on="on" v-bind="props" color="transparent" min-width="0" class="pa-0" @click="togglePastLives">
            <v-badge color="blue" content="1" overlap dot bordered>
              <v-icon color="grey lighten-2">mdi-bell</v-icon>
            </v-badge>
          </v-btn>
        </template>
        <div class="pt-9">
          <pastLives />
        </div>
      </v-menu>
      <v-menu :close-on-content-click="false" class="pt-9 pr-9" transition="slide-x-transition">
        <template v-slot:activator="{ on, props }">
          <v-btn v-on="on" v-bind="props" color="transparent" class="pa-0">
            <v-badge color="blue" overlap bordered dot>
              <v-icon color="grey lighten-2">mdi-earth</v-icon>
            </v-badge>
          </v-btn>
        </template>
        <v-list class="pt-9" color="transparent" width="460px" height="170px">
          <observationPost />
        </v-list>
      </v-menu>
      
      <!-- <trendingNews :trendingNews="trendingNews"/> -->
      <v-dialog v-model="showProgressBar" persistent width="110">
        <div v-show="showProgressBar" class="text-center">
          <v-progress-circular :rotate="-90" :size="80" :width="15" :value="progressBarValue" color="primary">
            <v-list-item-avatar class="mx-0">
              <v-img :src="profile_image"></v-img>
            </v-list-item-avatar>
          </v-progress-circular>
        </div>
      </v-dialog>
      <v-bottom-sheet width="1200px">
        <template v-slot:activator="{ props, on }">
          <v-btn color="transparent" class="pl-0 pr-0" v-bind="props" v-on="on" v-model="sheet">
            <v-list-item-group class="pr-0">
              <v-list-item-avatar size="45" class="v-img">
                <v-img :src="profile_image"></v-img>
              </v-list-item-avatar>
            </v-list-item-group>
          </v-btn>
        </template>
        <!------------------------------>
        <profilePage @fetch-user-data="getProfileData" />
        <!--End of sheet profile-->
      </v-bottom-sheet>
      <v-app-bar-nav-icon color="white" @click.stop="toggleRightMenu"></v-app-bar-nav-icon>
    </v-app-bar>
    <leftMenu v-if="openLeftDrawer" />
    <rightMenu v-if="openRightDrawer" />
    <v-responsive>
      <v-footer app clipped-left color="transparent" height="260%" width="7%" inset class="lighten-1 text-center">
        <v-card class="align-art flex-column" color="transparent">
          <!-- Beginning of dollar icon and dialog box -->
          <v-col cols="auto">
            <v-dialog persistent v-model="openFeedback" width="420"
              max-height="500">
              <template v-slot:activator="{ on, attrs }">
                <v-btn outlined small v-on="on" v-bind="attrs" fab class="ma-1 white-text" color="white">
                  <v-icon medium color="white" size="30">mdi-tooltip-question</v-icon>
                </v-btn>
              </template>
              <v-card outlined>
                <v-form v-model="form" ref="form" v-on:submit.prevent="handleFeedbackUpload">
                  <v-list-item three-line>
                    <v-list-item-content>
                      <div class="text-overline mb-4">
                        Tell us, what you think improve Triyangle?
                      </div>
                      <v-textarea v-model="feedbackMessage" outlined filled auto-grow></v-textarea>
                    </v-list-item-content>
                  </v-list-item>
                  <v-card-actions>
                    <v-row>
                      <v-col>
                        <v-btn outlined text @click="openFeedback = false">
                          Cancel
                        </v-btn>
                      </v-col>
                      <v-col>
                        <v-btn class="float-right" color="green" type="submit" rounded outlined text>
                          Send Feedback
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-card-actions>
                </v-form>
              </v-card>
            </v-dialog>
            <v-snackbar v-if="showSnackbar"
              v-model="showSnackbar"
              :timeout="timeout"
              color="success"
            >
              {{ feedbackSnackbarMessage }}
            </v-snackbar>
          </v-col>
          <v-col cols="auto">
            <v-dialog transition="dialog-bottom-transition" width="420" max-height="500">
              <template v-slot:activator="{ on }">
                <v-btn small v-on="on" fab class="ma-1 white-text" color="grey darken-1">
                  <v-icon medium color="white" size="30">mdi-cash-marker </v-icon>
                </v-btn>
              </template>
              <v-card max-width="420" color="grey lighten-2" class="mx-auto bordered">
                <v-toolbar color="blue darken-4" height="90" flat>
                  <template v-slot:prepend>
                    <v-btn icon="mdi-arrow-left"> </v-btn>
                  </template>

                  <v-text-field v-model="search" type="input" background-color="white" filled
                    placeholder="Search Active Organisations" hide-details clearable clear-icon="mdi-close-circle"
                    class="pr-3 pt-3"></v-text-field>
                  <span><v-icon color="white" class="pt-3">mdi-plus-circle</v-icon></span>
                  <template v-slot:append>
                    <v-btn icon="mdi-dots-vertical"></v-btn>
                  </template>
                </v-toolbar>
                <div v-if="keywords.length > 0" class="py-3 px-4">
                  <v-chip color="white" v-for="(keyword, i) in keywords" :key="i" class="me-2">
                    {{ keyword }}
                  </v-chip>
                </div>
                <v-container class="pa-2">
                  <v-row dense>
                    <v-col v-for="(item, i) in searching" :key="i" link>
                      <v-card>
                        <div class="d-flex flex-no-wrap justify-space-between">
                          <div>
                            <v-card-title class="text-h5" v-text="item.title"></v-card-title>
                            <v-card-subtitle v-text="item.description"></v-card-subtitle>
                            <v-card-actions>
                              <v-btn color="green darken-2" class="ml-2 white--text" outlined rounded small>
                                Donate Now
                              </v-btn>
                            </v-card-actions>
                          </div>

                          <v-avatar class="ma-3" size="125" tile>
                            <v-img :src="item.src"></v-img>
                          </v-avatar>
                        </div>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card>
            </v-dialog>
            <!-- End of Dollar sign icon -->

            <!-- Beginning of camera icon and dialog box -->
            <v-dialog persistent v-model="openPostDialog" max-width="500" max-height="500" class="ma-0">
              <template v-slot:activator="{ on }">
                <v-btn small v-on="on" fab class="ma-1 white--text" color="blue darken-3">
                  <v-icon>mdi-camera-plus</v-icon>
                </v-btn>
              </template>
              <template v-slot:default="dialog">
                <v-card>
                  <v-toolbar class="
                      text-xs-caption         
                      text-sm-caption         
                      text-md-caption          
                      text-lg-caption      
                      text-xl-h6
                    " color="primary" dark fluid height="50">
                    <v-list-item-avatar class="mx-0">
                      <v-img :src="profile_image"></v-img>
                    </v-list-item-avatar>
                    <v-icon class="px-2">mdi-pencil</v-icon>
                    Create a ping |
                    <v-icon class="px-2">mdi-camera</v-icon>
                    Photo/Video Album |
                    <v-icon class="px-2">mdi-message-video</v-icon>
                    Live Video
                    <v-spacer></v-spacer>
                    <v-btn icon darken-2 @click="openPostDialog = false">
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </v-toolbar>
                  <div class="text-h12 pa-1"></div>
                  <v-form v-on:submit.prevent="handleUpload()" v-model="form">
                    <v-list-item>
                      <v-row dense>
                        <v-col>
                          <v-file-input placeholder="Upload Image/Video" type="file" show-size v-model="uploadedFiles"
                            dense small-chips hide-details prepend-icon="mdi-camera"></v-file-input>
                        </v-col>
                        <v-col cols="12">
                          <v-textarea type="text" filled v-model="uploadedText" height="90px" dense hide-details="auto"
                            label="Post your thoughts"></v-textarea>
                          <v-text-field type="text" v-model="uploadedLink" filled class="pt-2" height="20px" dense
                            hide-details="auto" label="Add article link(if any)"></v-text-field>
                          <v-autocomplete label="Location" style="margin-top: 14px;" :items="countries" dense
                            return-object item-text="name" v-model="uploadLocation"></v-autocomplete>
                        </v-col>
                      </v-row>
                    </v-list-item>
                    <v-card-actions>
                      <v-col>
                        <v-btn class="float-right" type="submit" :disabled="!form" color="success" depressed @click="
                          dialog.value = false;
                        showProgressBar = true;
                        handleUploadProgressBar();">
                          Ping
                        </v-btn>
                      </v-col>
                    </v-card-actions>
                  </v-form>
                </v-card>
              </template>
            </v-dialog>
            <!-- End of camera dialog box -->
          </v-col>
        </v-card>
      </v-footer>
    </v-responsive>
  </v-card>
</template>

<script>
import axios from 'axios'
//import AuthService from '../../src/services/auth.service.js'
import { mapGetters, mapState } from 'vuex'
import countries from '../countries'
import trendingNews from './trendingNews'
import observationPost from './observationPost'
import pastLives from './pastLives'
import { apiUrl } from '../config'
import profilePage from './profilePage'
import leftMenu from './leftMenu'
import rightMenu from './rightMenu'

export default {
  data: () => ({
    openLeftDrawer: true,
    openRightDrawer: true,
    API_URL: apiUrl,
    form: "",
    arrayEvents: null,
    date1: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
    showTrendingNews: false,
    progressBarValue: 0,
    showProgressBar: false,
    uploadedFiles: null,
    uploadedText: "",
    uploadedLink: "",
    uploadLocation: "",
    isDisabled: true,
    dialog: "",
    sheet: "",
    message4: "",
    countries: [],
    profile_image: '',
    profileData: [""],
    openPostDialog: false,
    //feedback message fields
    openFeedback: false,
    feedbackMessage: "",
    error: null,
    success: null,
    username: "",
    feedbackSnackbarMessage: "Your feedback was sent successfully.",
    timeout: 5000,
    showSnackbar: false,
    items: [
      {
        color: 'blue darken-3',
        src: 'https://cdn.vuetifyjs.com/images/cards/foster.jpg',
        title: 'Haiti Recovery Fund',
        description: 'Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old.',
        keyword: 'Support Mission',
      },
      {
        color: 'blue',
        src: 'https://cdn.vuetifyjs.com/images/cards/halcyon.png',
        title: 'Burkina Faso Food Fund',
        description: 'The standard chunk of those interested. Sections 1.10.32 and 1.10.33 from "de Finibus Bonorum et Malorum" by Cicero are also reproduced in their exact original form, translation by H. Rackham.',
        keyword: 'Food',
      },
      {
        color: 'blue',
        src: 'https://cdn.vuetifyjs.com/images/cards/foster.jpg',
        title: 'Mali agriculture program',
        description: 'Proin ante nibh, congue sit amet fringilla varius, tempor laoreet sem. Nullam in dolor tristique, luctus odio eu, posuere ligula. Proin Etiam sagittis eu erat iaculis vulputate.',
        keyword: 'Agriculture',
      },
      {
        color: 'blue',
        src: 'https://cdn.vuetifyjs.com/images/cards/halcyon.png',
        title: 'Congo Mining Program',
        description: 'Vestibulum tempus ante vitae massa pharetra, eget suscipit orci consequat. Aliquam commodo fringilla eros id ultrices. Suspendisse feugiat lorem nisi, nec luctus leo hendrerit eu.',
        keyword: 'Economic Mission',
      },
    ],
    // Third list - Chats
    //
    recent: [
      {
        active: true,
        avatar: 'https://cdn.vuetifyjs.com/images/lists/1.jpg',
        title: 'Jason Oner',
      },
      {
        active: true,
        avatar: 'https://cdn.vuetifyjs.com/images/lists/2.jpg',
        title: 'Mike Carlson',
      },
      {
        avatar: 'https://cdn.vuetifyjs.com/images/lists/3.jpg',
        title: 'Cindy Baker',
      },
      {
        avatar: 'https://cdn.vuetifyjs.com/images/lists/4.jpg',
        title: 'Ali Connors',
      },
    ],
    previous: [
      {
        title: 'Travis Howard',
        avatar: 'https://cdn.vuetifyjs.com/images/lists/5.jpg',
      },
    ],
    search: '',
  }),
  drawer: true,
  mini: true,
  expand: false,
  methods: {
    async submitFeedback(formData) {
      try {
        let user = localStorage.getItem('user');
        user = JSON.parse(user);

        const authToken = 'Bearer ' + user['access'];

        this.error = null;
        this.success = null;
        const response = await axios.post(
          `${this.API_URL}feedback/`, formData,
          { 
            headers: { 'Authorization': authToken, 
              'Content-Type': 'multipart/form-data',
            } 
          }
        );
        console.log('API Response:', response);

        // Check if the status code is 201 (Created)
        if (response.status === 201) {
          this.showSnackbar = true;
          this.openFeedback = false;
          this.$refs.form.reset();
          return true; // Success
        } else {
          console.error('Unexpected status code:', response.status);
          return false; // Not successful
        }
      } catch (error) {
        console.error('Error creating feedback:', error);
        return false; // Failure
      }
    },
    //Handle Feedback upload
    async handleFeedbackUpload() {

      this.isLoading = true
      const feedbackIdeaData = {
        feedbackMessage: this.feedbackMessage,
      };

      console.log('feedback data from feedbackform', feedbackIdeaData);

      const formData = new FormData();
      formData.append('message', this.feedbackMessage);
    
      this.isLoading = false
    },
    triggerTrendingNews() {
      this.$emit('fetchTrendingNews');
    },
    //Menu functionality
    toggleleftMenu() {
      return this.openLeftDrawer = !this.openLeftDrawer
    },
    toggleRightMenu() {
      return this.openRightDrawer = !this.openRightDrawer
    },
    async getProfileData() {
      try {
        // fetch profile
        let user = localStorage.getItem('user');
        user = JSON.parse(user);

        const authToken = 'Bearer ' + user['access'];

        console.log(authToken)

        const response = await axios.get(`${this.API_URL}users/current-user/`, {
          headers: {
            'Authorization': authToken,
          },
        })
        // set the data returned as profile
        this.profileData = response.data;
        this.profile_image = this.profileData?.profile.profile_image;
        console.log(this.profileData);

      } catch (error) {
        // log the error
        console.log(error);
      }
    },
    togglePastLives() { },
    reserve() { },
    handleUploadProgressBar() {
      setInterval(() => {
        if (this.progressBarValue === 100) {
          this.showProgressBar = false;
          this.progressBarValue = 0;
          return;
        }
        this.progressBarValue += 20;
        //console.log(progressBarValue);
      }, 1000);
    },
    async createPost(formData) {
      try {
        let user = localStorage.getItem('user');
        user = JSON.parse(user);

        const authToken = 'Bearer ' + user['access'];

        console.log(authToken);

        const response = await axios.post(`${this.API_URL}posts/`, formData, {
          headers: {
            'Authorization': authToken,
            'Content-Type': 'multipart/form-data',
          },
        });

        console.log('API Response:', response);

        // Check if the status code is 201 (Created)
        if (response.status === 201) {
          return true; // Success
        } else {
          console.error('Unexpected status code:', response.status);
          return false; // Not successful
        }
      } catch (error) {
        console.error('Error creating business idea:', error);
        return false; // Failure
      }
    },

    //handle upload method
    async handleUpload() {
      if (this.uploadLocation && this.uploadedText || this.uploadedLink || this.uploadedFiles) {

        const postData = {
          content: this.uploadedText,
          link: this.uploadedLink,
          location: this.uploadLocation.name,
          files: this.uploadedFiles
        }

        console.log('postdata from navbar', postData)

        const formData = new FormData();
        formData.append('content', this.uploadedText);
        formData.append('link', this.uploadedLink);
        formData.append('location', this.uploadLocation.name);
        if (this.uploadedFiles !== null) {
          formData.append('files', this.uploadedFiles);

        }

        const isSuccess = await this.createPost(formData)

        if (isSuccess) {

          this.$emit('fetch-posts')
        }

        // this.$store.dispatch('auth/post', formData).then(() => {
        //   // ... handle any further logic or UI updates
        //   this.$success('Post added successfully!');
        // }).catch(error => {
        //   // ... handle error condition
        //   console.log(error)
        //   this.$error(error)
        // });
      }
    },
    handleUploadLocation(country) {
      this.uploadLocation = country;
    },
    getCountry(country) {
      this.$emit('country', country)
    },
    toggleTrendingNews() {
      this.showTrendingNews = !this.showTrendingNews;
    },
  },
  created() {
    this.getProfileData();
  },
  mounted() {
    this.countries = countries
    this.arrayEvents = [...Array(6)].map(() => {
      const day = Math.floor(Math.random() * 30)
      const d = new Date()
      d.setDate(day)
      return d.toISOString().substr(0, 10)
    })
  },
  components: {
    trendingNews,
    pastLives,
    profilePage,
    leftMenu,
    rightMenu,
    observationPost,
  },
  watch: {
    message(logMessage) {
      console.log('Name:', logMessage)
    },
    location(logMessage) {
      console.log('Locaion:', logMessage)
    },
    link(logMessage) {
      console.log('Link:', logMessage)
    },
  },
  computed: {
    ...mapState(['user']),
    ...mapGetters({ user: "auth/user" }, { token: "auth/user" }),
    keywords() {
      if (!this.search) return []

      const keywords = []

      for (const search of this.searching) {
        keywords.push(search.keyword)
      }

      return keywords
    },
    searching() {
      if (!this.search) return this.items

      const search = this.search.toLowerCase()

      return this.items.filter(item => {
        const text = item.title.toLowerCase()

        return text.indexOf(search) > -1
      })
    },
  },
  props: {
    trendingNews: Array,
  }
}
</script>